(function() {
    const $skioPortal = document.getElementById('__next');

    if ($skioPortal) {
        let buttonsReorded = false

        const observer = new MutationObserver((mutationsList, observer) => {
            observer.disconnect();

            mutationsList.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    const targetNode = $skioPortal.querySelector('.CP0.Jea.Uxw.hA-.kzZ.wYR.wfr.z4_.zI7.iyn.Hsu');
                    if (targetNode) {
                        console.log(targetNode.children);

                        let $loyaltyButton = document.querySelector('button[aria-label="Loyalty"]')
                        if (!$loyaltyButton) {
                            // add loyalty button
                            const newButton = '<div class="C9q Shl zI7 iyn Hsu rewards"><button class="Button_button__r9EP_ Button_button-fill__V04My Button_buttonFillHover__KjoZH" data-testid="button" role="button" type="button" aria-label="Loyalty" style="background: rgb(254, 221, 0); color: rgb(0, 0, 0);"><span aria-hidden="true" data-testid="typography" class="undefined Typography_margin-reset__Z2GFR Typography_text-small-bold__DspOh" style="color: rgb(0, 0, 0); overflow: hidden;">Loyalty</span></button></div>';
                            targetNode.insertAdjacentHTML('beforeend', newButton);

                            const $newButton = targetNode.querySelector('button[aria-label="Loyalty"]');

                            if ($newButton) {
                                $newButton.addEventListener('click', function() {
                                    window.location.href = 'https://www.animalpak.com/pages/loyalty';
                                });
                            }
                        }

                        // reorder
                        // Assuming children[0] to children[3] are buttons 1 to 4 respectively
                        let children = Array.from(targetNode.children);

                        console.log(children[3].querySelector('button').ariaLabel == 'Logout')

                        let buttonsReorded = children[3].querySelector('button').ariaLabel == 'Logout'

                        if (buttonsReorded) {
                            // Desired final order: 2, 4, 1, 3
                            targetNode.appendChild(children[2]) //backup card
                            targetNode.appendChild(children[1]) //history
                            targetNode.appendChild(children[4]) //loyalty
                            targetNode.appendChild(children[0]) //returns
                            targetNode.appendChild(children[3]) //logout

                            buttonsReorded = true
                        }
                    }
                }
            });
            observer.observe($skioPortal, {
                childList: true,
                subtree: true
            });
        });

        observer.observe($skioPortal, {
            childList: true,
            subtree: true
        });
    } else {
        console.log("element with id '__next' does not exist");
    }
})();
